import { assignInlineVars } from '@vanilla-extract/dynamic';
import clsx from 'clsx';
import { type CSSProperties, memo, type ReactElement, type Ref } from 'react';

import { Button, type ButtonProps } from './button';
import { iconButton, iconSizeVar } from './button.css';

export interface IconButtonProps
  extends Omit<
    ButtonProps,
    | 'variant'
    | 'size'
    | 'prefix'
    | 'suffix'
    | 'children'
    | 'prefixClassName'
    | 'prefixStyle'
    | 'suffix'
    | 'suffixClassName'
    | 'suffixStyle'
  > {
  children?: ReactElement;
  icon?: ReactElement;
  variant?: 'plain' | 'solid' | 'danger' | 'custom';
  size?: '12' | '14' | '16' | '20' | '22' | '24' | number;
  iconClassName?: string;
  iconStyle?: CSSProperties;
}

export const IconButton = memo(
  ({
    ref,
    variant = 'plain',
    size = '20',
    style,
    className,
    children,
    icon,
    iconClassName,
    iconStyle,
    ...otherProps
  }: IconButtonProps & { ref?: Ref<HTMLButtonElement> }) => {
    const validatedSize = isNaN(parseInt(size as string, 10)) ? 16 : size;

    return (
      <Button
        ref={ref}
        style={{
          ...style,
          ...assignInlineVars({
            [iconSizeVar]: `${validatedSize}px`,
          }),
        }}
        data-icon-variant={variant}
        data-icon-size={validatedSize}
        className={clsx(iconButton, className)}
        size={'custom'}
        variant={'custom'}
        prefix={children ?? icon}
        prefixClassName={iconClassName}
        prefixStyle={iconStyle}
        {...otherProps}
      />
    );
  }
);

export default IconButton;
